import React from 'react'

import { Box, Paper } from '@material-ui/core'

import ItemLoading from './../ItemLoading'

const ContainerSummary = ({ isLoading, children: childrenProp }) => {
  const children = React.Children.toArray(childrenProp)

  return (
    <Paper>
      <Box display="flex" flexWrap="wrap" justifyContent="space-evenly">
        {children.map((item, index) => {
          if (!isLoading) {
            return item
          }

          return <ItemLoading key={index} />
        })}
      </Box>
    </Paper>
  )
}

export default ContainerSummary
